export const options = [ 
    {
        id:1,
        opt:"Accounting"
    },
    {
        id:2,
        opt:"Airlines/Aviation"
    },
    {
        id:3,
        opt:"Alternative Dispute Resolution"
    },
    {
        id:4,
        opt:"Alternative Medicine"
    },
    {
        id:5,
        opt:"Animation"
    },
    {
        id:6,
        opt:"Apparel & Fashion"
    },
    {
        id:7,
        opt:"Architecture & Planning"
    },
    {
        id:8,
        opt:"Arts and Crafts"
    },
    {
        id:9,
        opt:"Automotive"
    },
    {
        id:10,
        opt:"Avitaion & Aerospace"
    },
    {
        id:11,
        opt:"Banking"
    },
    {
        id:12,
        opt:"Biotechnology"
    },
    {
        id:13,
        opt:"Broadcast Media"
    },
    {
        id:14,
        opt:"Building Materials"
    },
    {
        id:15,
        opt:"Business Supplies and Equipment"
    },
    {
        id:17,
        opt:"Captial Markets"
    },
    {
        id:18,
        opt:"Chemicals"
    },
    {
        id:19,
        opt:"Civic & Social Organization"
    },
    {
        id:20,
        opt:"Civil Engineering"
    },
    {
        id:21,
        opt:"Commerical Real Estate"
    },
    {
        id:22,
        opt:"Computer & Network Security"
    },
    {
        id:23,
        opt:"Computer Games"
    },
    {
        id:24,
        opt:"Computer Hardware"
    },
    {
        id:25,
        opt:"Computer Networking"
    },
    {
        id:26,
        opt:"Computer Software"
    },
    {
        id:27,
        opt:"Construction"
    },
    {
        id:28,
        opt:"Consumer Electronics"
    },
    {
        id:29,
        opt:"Consumer Goods"
    },
    {
        id:30,
        opt:"Cosmetics"
    },
    {
        id:31,
        opt:"Dairy"
    },
    {
        id:32,
        opt:"Defense & Space"
    },
    {
        id:33,
        opt:"Design"
    },
    {
        id:34,
        opt:"E-Learning"
    },
    {
        id:35,
        opt:"Education Management"
    },
    {
        id:36,
        opt:"Electrical/Electronic Manufacturing"
    },
    {
        id:37,
        opt:"Entertainment"
    },
    {
        id:38,
        opt:"Environmental Services"
    },
    {
        id:39,
        opt:"Events Services"
    },
    {
        id:40,
        opt:"Executive Office"
    },
    {
        id:41,
        opt:"Facilities Services"
    },
    {
        id:42,
        opt:"Farming"
    },
    {
        id:43,
        opt:"Financial Services"
    },
    {
        id:44,
        opt:"Fine Art"
    },
    {
        id:45,
        opt:"Food & Beverages"
    },
    {
        id:46,
        opt:"Food Production"
    },
    {
        id:47,
        opt:"Fund-Raising"
    },
    {
        id:48,
        opt:"Furniture"
    },
    {
        id:49,
        opt:"Gambling & Casinos"
    },
    {
        id:50,
        opt:"Glass, Ceramics & Concrete"
    },
    {
        id:51,
        opt:"Government Administration"
    },
    {
        id:52,
        opt:"Government Relations"
    },
    {
        id:53,
        opt:"Graphic Design"
    },
    {
        id:54,
        opt:"Health, Wellness and Fitness"
    },
    {
        id:55,
        opt:"Higher, Education"
    },
    {
        id:56,
        opt:"Hospital & Health Care"
    },
    {
        id:57,
        opt:"Hospitality"
    },
    {
        id:58,
        opt:"Import and Export"
    },
    {
        id:60,
        opt:"Individual & Family Services"
    },
    {
        id:61,
        opt:"Industrial Automation"
    },
    {
        id:62,
        opt:"Information Services"
    },
    {
        id:63,
        opt:"Information Technology and Services"
    },
    {
        id:64,
        opt:"Insurance"
    },
    {
        id:65,
        opt:"International Affairs"
    },
    {
        id:66,
        opt:"International Trade and Development"
    },
    {
        id:67,
        opt:"Internet"
    },
    {
        id:68,
        opt:"Investment Banking"
    },
    {
        id:69,
        opt:"Judiciary"
    },
    {
        id:70,
        opt:"Law Enforcement"
    },
    {
        id:71,
        opt:"Law Practice"
    },
    {
        id:72,
        opt:"Legal Services"
    },
    {
        id:73,
        opt:"Legislative Office"
    },
    {
        id:74,
        opt:"Leisure, Travel & Tourism"
    },
    {
        id:75,
        opt:"Libraries"
    },
    {
        id:76,
        opt:"Logistics and Supply Chain"
    },
    {
        id:77,
        opt:"Luxury Goods * Jewelry"
    },
    {
        id:78,
        opt:"Machinery"
    },
    {
        id:79,
        opt:"Management Consulting"
    },
    {
        id:80,
        opt:"Maritime"
    },
    {
        id:81,
        opt:"Market Research"
    },
    {
        id:82,
        opt:"Marketing and Advertising"
    },
    {
        id:83,
        opt:"Mechanical or Industrial Engineering"
    },
    {
        id:84,
        opt:"Media Production"
    },
    {
        id:85,
        opt:"Medical Devices"
    },
    {
        id:86,
        opt:"Medical Practice"
    },
    {
        id:87,
        opt:"Mental Health Care"
    },
    {
        id:88,
        opt:"Military"
    },
    {
        id:89,
        opt:"Mining & Metals"
    },
    {
        id:90,
        opt:"Motion Pictures and Film"
    },
    {
        id:91,
        opt:"Museums and Institutions"
    },
    {
        id:92,
        opt:"Music"
    },
    {
        id:93,
        opt:"Nanotechonlogy"
    },
    {
        id:94,
        opt:"Newspaper"
    },
    {
        id:95,
        opt:"Nonprofit Organization Management"
    },
    {
        id:96,
        opt:"Oil & Energy"
    },
    {
        id:97,
        opt:"Online Media"
    },
    {
        id:98,
        opt:"Outsourcing/Offshoring"
    },
    {
        id:99,
        opt:"Package/Freight Delivery"
    },
    {
        id:100,
        opt:"Packaging and Containers"
    },
    {
        id:101,
        opt:"Paper & Forest Products"
    },
    {
        id:102,
        opt:"Performing Arts"
    },
    {
        id:103,
        opt:"Pharmaceuticals"
    },
    {
        id:104,
        opt:"Philanthropy"
    },
    {
        id:105,
        opt:"Photography"
    },
    {
        id:106,
        opt:"Plastics"
    },
    {
        id:107,
        opt:"Political Organization"
    },
    {
        id:108,
        opt:"Primary/Secondary Education"
    },
    {
        id:109,
        opt:"Printing"
    },
    {
        id:110,
        opt:"Professional Training & Coaching"
    },
    {
        id:111,
        opt:"Program Development"
    },
    {
        id:112,
        opt:"Public Policy"
    },
    {
        id:113,
        opt:"Public Relations and Communications"
    },
    {
        id:114,
        opt:"Public Safety"
    },
    {
        id:115,
        opt:"Railroad Manufacture"
    },
    {
        id:116,
        opt:"Ranching"
    },
    {
        id:117,
        opt:"Real Estate"
    },
    {
        id:118,
        opt:"Recreational Facilities and Services"
    },
    {
        id:119,
        opt:"Religious Institutions"
    },
    {
        id:120,
        opt:"Renewables & Environment"
    },
    {
        id:121,
        opt:"Research"
    },
    {
        id:122,
        opt:"Restaurants"
    },
    {
        id:123,
        opt:"Retail"
    },
    {
        id:124,
        opt:"Security and Investigations"
    },
    {
        id:125,
        opt:"Semiconductors"
    },
    {
        id:126,
        opt:"Shipbuilding"
    },
    {
        id:127,
        opt:"Sporting Goods"
    },
    {
        id:128,
        opt:"Staffing and Recruiting"
    },
    {
        id:129,
        opt:"Supermarkets"
    },
    {
        id:130,
        opt:"Telecommunications"
    },
    {
        id:131,
        opt:"Textiles"
    },
    {
        id:132,
        opt:"Think Tanks"
    },
    {
        id:133,
        opt:"Tobacco"
    },
    {
        id:134,
        opt:"Translation and Localization"
    },
    {
        id:135,
        opt:"Transportation/Trucking/Railroad"
    },
    {
        id:136,
        opt:"Utilities"
    },
    {
        id:137,
        opt:"Venture Capital & Private Equity"
    },
    {
        id:138,
        opt:"Veterinary"
    },
    {
        id:139,
        opt:"Warehousing"
    },
    {
        id:140,
        opt:"Wholesale"
    },
    {
        id:141,
        opt:"Wine and Spirits"
    },
    {
        id:142,
        opt:"Wireless"
    },
    {
        id:143,
        opt:"Writing and Editing"
    },
]       